<template>
  <div :class="`position-relative task-sidebar ${collapsingClass} ${collapsedClass}`">
                <div class="position-fixed task-sidebar__actions" pt=1 pb=1>
                    <div class="d-flex justify-content-center">
                        <span class="link-primary" v-if="tenantPresent" @click="newTask()" :title="$t('newTask')"><i class="bi bi-plus-circle" font-size="1.5"></i></span>
                        <span class="link-disabled" v-else :title="$t('newTaskWithoutTenant')"><i class="bi bi-plus-circle" font-size="1.5"></i></span>
                    </div>
                    <div class="d-flex justify-content-center" mt="1">
                        <span class="link-primary" @click="collapse()" :title="$t(collapseTranslationKey)"><i class="bi bi-calendar-check" font-size="1.5"></i></span>
                    </div>
                </div>
                <div class="task-sidebar__content">
                    <div p=1>
                        <div class="d-flex justify-content-center" mb="1">
                            <div>
                                <vue-my-calendar @ondayclick="dayClickHandler($event)" :date-selected="dateSelected">
                                </vue-my-calendar>
                            </div>
                        </div>
                        <div flex-box flex-column-direction>
                          <div>
                            <div>
                                <span class="font-bold">{{ $t("select_day_activities") }}</span>
                                <div>
                                    <template v-for="(task) in getSavedTasks">
                                        <vue-admin-tasks-task-list-item :task-data="task" :key="task.renderId"></vue-admin-tasks-task-list-item>
                                    </template>
                                </div>
                            </div>
                            <div>
                                <div mt="1" mb="1">
                                      <div class="d-flex">
                                          <div>
                                              <i class="text-success bi bi-dash-lg"></i>
                                          </div>
                                          <div ml="0.5">
                                              <span font-size="1">{{ $t("finished_activities") }}</span>
                                          </div>
                                      </div>
                                </div>
                                <div mt="1" mb="1">
                                    <div class="d-flex">
                                        <div>
                                            <i class="text-warning bi bi-dash-lg"></i>
                                        </div>
                                        <div ml="0.5">
                                            <span font-size="1">{{ $t("incomplete_activities") }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                          </div>
                          <div>
                            <div>
                              <span class="font-bold">{{ $t("archived_activities") }}</span>
                              <div>
                                <template v-for="(task) in getArchivedTasks">
                                  <vue-admin-tasks-task-list-item :task-data="task" :key="task.renderId"></vue-admin-tasks-task-list-item>
                                </template>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex';

export default{
  data: function() {
    return {
      collapsed: false,
      collapsing: false
    }
  },
  props: {
    tenantPresent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('taskStoreModule', ['tasks', 'dateSelected']),
    ...mapGetters('taskStoreModule', ['getSavedTasks', 'getArchivedTasks']),
    collapsingClass: function(){
      if(this.collapsed && this.collapsing){
        return 'collapsing-in'
      }
      if(!this.collapsed && this.collapsing){
        return 'collapsing-out';
      }
      return '';
    },
    collapsedClass: function(){
      return (this.collapsed && !this.collapsing) ? 'collapsed' : ''
    },
    collapseTranslationKey: function(){
      return (this.collapsed && !this.collapsing) ? 'collapseIn' : 'collapseOut'
    }
  },
  methods: {
    ...mapActions('taskStoreModule', ['setDateSelected', 'newTask']),
    collapse(){
      this.collapsing=true;
      if(!this.collapsed){
        setTimeout(() => {
          this.collapsed=true;
          this.collapsing=false;
        }, 500)
      }else{
        setTimeout(() => {
          this.collapsed=false;
          this.collapsing=false;
        }, 500)
      }
    },
    dayClickHandler(date){
      this.setDateSelected({date: date, setURL: true})
    },
    translate(key){
      return $t(`task_sidebar.${key}`);
    }
  },
  i18n: {
    messages: {
      "pt-BR": {
        select_day_activities: "Suas atividades do dia selecionado",
        archived_activities: "Atividades arquivadas",
        finished_activities: "Todas atividade concluidas",
        incomplete_activities: "Atividades incompletas",
        newTask: 'Nova tarefa',
        newTaskWithoutTenant: 'O grupo deve ser selecionado antes de criar uma nova tarefa',
        collapseOut: 'Ocultar barra de tarefas',
        collapseIn: 'Mostrar barra de tarefas',
      },
      en: {
        select_day_activities: "Your activities for day selected",
        archived_activities: "Archived activities",
        finished_activities: "Complete activities",
        incomplete_activities: "Incomplete activities",
        newTask: 'New task',
        newTaskWithoutTenant: 'A group must be selected to create a new task',
        collapseOut: 'Hide task bar',
        collapseIn: 'Show task bar',
      }
    }
  }
}
</script>
